require("./style.css");
import React from "react";
import map from "lodash/map";
import take from "lodash/take";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import filter from "lodash/filter";
import AcquireWebComponent from "../../framework/MaterialUI";
import Select from "react-select";
import Highlighter from "react-highlight-words";
import { splitNumber } from "../../../utils/utility";

import { Link } from "react-router-dom";

class MostPopularPageInsights extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageCount: 20,
      filter: "",
      errorKey: "",
      mostPopularPages: undefined,
      showEmptyError: false,
    };
  }

  componentWillUpdate(nextProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.setState({
        mostPopularPages: nextProps.data,
      });
    }
  }

  renderNoDate() {
    return (
      <div style={{ width: '100%', minHeight: '180px', textAlign: 'center', paddingTop: '80px', color: "#CDCDCD" }}>
        <div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
      </div>
      );
  }

  render() {
    const {
      loadingPopularPages,
      loadingPopularPagesError,
      client_info,
      pdfCreating
    } = this.props;
    const containerheight = this.state.pageCount === 20 ? "auto" : "800px";
    const pages = take(this.state.mostPopularPages, this.state.pageCount);

    const filterPages = isEmpty(this.state.filter)
      ? pages
      : filter(pages, page => {
          return page.pageUrl.indexOf(this.state.filter) >= 0;
        });

    const route = window.location.pathname + window.location.search;

    return (
      <div className="mt-20 p-20 light-grey-border" id="most-popular-pdf-mark">
        <div>
          <h1 className="no-margin popular-pdf-part" style={{fontWeight: 'bold'}}>Most Popular Pages</h1>
        </div>
        <div style={{ display: "flex", marginTop: "20px" }}>
          <div style={{ flex: "1 1 420px" }}>
            <div
              style={{
                display: "inline-block",
                marginRight: "10px",
              }}
            >
              <strong>Popular page search</strong>
            </div>
            <input
              type="text"
              onChange={e => {
                this.setState({ filter: e ? e.target.value : "" });
              }}
              style={{
                width: "250px",
                border: "solid 1px #BDBDBD",
                marginTop: "5px",
                marginLeft: "10px",
                padding: "5px 10px",
                lineHieght: "20px",
              }}
            />
          </div>
          <div style={{ flex: "1 1 200px", textAlign: "right" }}>
            <div
              style={{
                display: "inline-block",
                marginRight: "0px",
              }}
            >
              View
            </div>
            {client_info &&
            parseInt(client_info.subscriptionTierId, 10) >= 3 ? (
              <Select
                className="pop-pages-count-selector"
                name=""
                value={this.state.pageCount}
                clearable={false}
                searchable={false}
                onChange={e => {
                  this.setState({ pageCount: e.value });
                }}
                options={[
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                  { value: 100, label: "100" },
                ]}
              />
            ) : (
              <span className="ml-10" style={{ marginRight: "-10px" }}>
                20
              </span>
            )}
            <div
              style={{
                display: "inline-block",
                marginLeft: "20px",
              }}
            >
              Popular Pages
            </div>
          </div>
        </div>
        <div
          className="popular-pdf-part"
          style={{
            marginTop: "20px",
            padding: "10px 20px 20px",
            background: "#F5F5F5",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "85%", paddingTop: "10px" }}>
            <strong>Page Name</strong>
          </div>
          <div style={{ width: "15%", paddingTop: "10px" }}>
            <strong>Total Visits</strong>
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
          }}
        >
          <div
            style={{
              overflowY: containerheight === "auto" ? "hidden" : "auto",
              height: containerheight,
              display:
                loadingPopularPages || loadingPopularPagesError
                  ? "none"
                  : "block",
            }}
          >
            {filterPages && filterPages.length > 0 ? map(filterPages, page => {
              return (
                <div
                  key={"page-" + page.pageUrl}
                  className="light-grey-border-bottom popular-pdf-part"
                  style={{ padding: "10px 20px 20px", display: "flex" }}
                >
                  <div
                    style={{
                      width: "85%",
                      paddingTop: "10px",
                      paddingRight: "20px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {client_info &&
                    parseInt(client_info.subscriptionTierId, 10) >= 3 ? (
                      <Link
                        to={
                          route + "&pop_url=" + encodeURIComponent(page.pageUrl)
                        }
                      >
                        {isEmpty(this.state.filter) ? (
                          page.pageUrl
                        ) : (
                          <Highlighter
                            highlightClassName="clickable"
                            searchWords={[this.state.filter]}
                            autoEscape={true}
                            textToHighlight={page.pageUrl}
                          />
                        )}
                      </Link>
                    ) : (
                      <Highlighter
                        highlightClassName="clickable"
                        searchWords={[this.state.filter]}
                        autoEscape={true}
                        textToHighlight={page.pageUrl}
                      />
                    )}
                  </div>
                  <div style={{ width: "15%", paddingTop: "10px" }}>
                    {splitNumber(page.totalVisits + "")()}
                  </div>
                </div>
              );
            }) : this.renderNoDate()}
          </div>
        </div>
      </div>
    );
  }
}

export default MostPopularPageInsights;



// WEBPACK FOOTER //
// ./src/components/Insights/website/MostPopularPage.jsx